import { connect } from 'react-redux';
import { getNotificationCount } from '@/redux/modules/notification';
import { PureComponent } from 'react';

type OwnProps = {};

const mapStateToProps = (state: any) => {
    const count = getNotificationCount(state);
    return { count };
};

type ReduxProps = {
    count: number;
};

type Props = OwnProps & ReduxProps;

class NotificationCountTitle extends PureComponent<Props> {
    componentDidUpdate(prevProps) {
        const { count } = this.props;
        const replace = /\(\d+\)/;
        if (document?.title) {
            if (count > 0) {
                document.title = `(${count}) ${document.title.replace(replace, '')}`;
            } else if (prevProps.count > 0) {
                document.title = document.title.replace(replace, '');
            }
        }
    }
    render() {
        return null;
    }
}

export default connect(mapStateToProps)(NotificationCountTitle);
